import React from 'react';
import './footer.css'
import pic30 from '../../assets/pic30.png'
import pic31 from '../../assets/pic31.png'
import pic32 from '../../assets/pic32.png'
import pic33 from '../../assets/pic33.png'
import pic34 from '../../assets/pic34.png'
import pic35 from '../../assets/pic35.png'
import Listfootertext from '../common/list-footer';
import gsap from 'gsap';
import { useEffect } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom';
gsap.registerPlugin(ScrollTrigger);





const Footerr = () => {

useEffect(() => {
    if (window.innerWidth > 1920) return;

    gsap.set('.footerrr', { yPercent: -50 });

    const uncover = gsap.timeline({ paused: true });
    uncover.to('.footerrr', { yPercent: 0, ease: 'none' });

    ScrollTrigger.create({
      trigger: '.body-bg',    
      start: 'bottom bottom',
      end: '+=75%',
      animation: uncover,
      scrub: true,
    });
}, []);




    return ( 
        <footer className='footerrr'>
            <nav className='footer2'>
            <svg 
              className='wavesvg'
            xmlns="http://www.w3.org/2000/svg" 
            width="100%" 
            height="auto"
            viewBox="0 0 1280 305" 
            fill="none"
            >
<path d="M-78.0958 0H1338.32C1338.32 131.679 1234.36 239.873 1102.79 245.13L1013.51 248.698L704.322 299.26C660.735 306.388 616.248 306.002 572.791 298.119L199.394 230.385C181.556 227.149 163.416 225.888 145.302 226.626C23.4206 231.587 -78.0958 134.118 -78.0958 12.1358V0Z" fill="#1B2932"/>

            </svg>

            <nav className='footerr-main-container'>
                <article className='container-footerrr'>
                   <img src={pic30} alt='logo'></img>
                   <p className='para-footer'>Delivering premium dairy products straight from 
                    our farms to your table—fresh, pure, and crafted with
                     care every step of the way.</p>     

                    <nav className='social-media-links'>
                        <img src={pic31} alt='instagram'></img>
                        <img src={pic32} alt='facebook'></img>    
                        <img src={pic33} alt='tiktok'></img>
                        <img src={pic34} alt='youtube'></img>                                          
                    </nav>
                </article>

            <nav className='navigations-cont-footerr'>
                        <nav className='big-list-footer'>
                            <h2 className='list-title-footer'>Explore</h2>

                            <ul className='smalllist-footer'>
                                <Link to='/'>
                                     <Listfootertext list='Home page' />
                                </Link>
                                 <Link to='/Exhibition-Exhibitors'>
                                     <Listfootertext list='Exhibitors' />    
                                 </Link> 
                                 <Link to='/booking'>
                                  <Listfootertext list='Booking' /> 
                                  </Link>
                                  <Link to='/gallery'>
                                   <Listfootertext list='About' />   
                                   </Link>  
                                   <Link to='/about'>
                                    <Listfootertext list='Gallery' /> 
                                </Link>                                                                                                                              
                            </ul>
                        </nav>


                        <nav className='big-list-footer'>
                            <h2 className='list-title-footer'>Legal</h2>

                            <ul className='smalllist-footer'>
                                <Listfootertext list='Terms & Conditions' />
                                 <Listfootertext list='Cookies' />      
                                  <Listfootertext list='Privacy Policy' />                                                                                                                       
                            </ul>
                        </nav>

                    <img className='img-footer' src={pic35} alt='illustration'></img>


            </nav>

            </nav>

            <nav className='last-part-footer-cont'>
                <h5 className='copyrights'>@2026,workspace,AllRightsReservedbyworkspace</h5>
            </nav>

</nav>
        </footer>
     );
}
 
export default Footerr;